// ContractsIndex.tsx
 import { useParams } from 'react-router-dom';
import { Card, CardBody } from '@components/card/card.jsx';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
 import ContractsTab from './ContractsTab';
import { useAppSelector } from '@store/hooks';

const Index = () => {
  const { personId } = useParams();
  const { Employees } = useAppSelector(state => state.Employees);
  const { i18n } = useTranslation();

  // البحث عن بيانات الموظف باستخدام personId
  const employee: any = Employees?.find((emp: any) => emp.id === personId);

  const BreadcrumbList = [
    {
      name: 'الرئيسية',
      link: ':moduleHome'
    },
    {
      name: 'الموظفين',
      link: '/HR/Employees'
    },
    {
      name: 'العقود',
      link: null
    }
  ];
  return (
    <div>
      <Breadcrumb BreadcrumbList={BreadcrumbList} PageName='العقود' />

      {/* كرت معلومات الموظف */}
      <Card className='mb-4'>
        <CardBody>
          <div className='d-flex align-items-center justify-content-between'>
            <div>
              <h5 className='mb-1'>
                <i className='fa fa-user me-2 text-theme'></i>
                {i18n.language === 'ar' ? employee?.name2 : employee?.name}
              </h5>
              <small className='text-muted'>رقم الموظف: {employee?.employeeNumber || 'غير محدد'}</small>
            </div>
            <div>
              <span className={`badge ${employee?.endOfServiceDate ? 'bg-danger' : 'bg-success'}`}>
                {employee?.endOfServiceDate ? 'منتهي الخدمة' : 'على رأس العمل'}
              </span>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* محتوى العقود */}
      {personId && <ContractsTab personId={personId} />}
    </div>
  );
};

export default Index;
